import { lazy, ReactElement } from 'react';

import { Navigate, Route, Routes } from 'react-router';

import appPage from '../../../hoc/appPage';
import { importantQueryString } from '../../../lib/importantParams';
import { AuthForm } from '../../../views/AuthView/AuthFormEnum';

const AuthView = lazy(() => import('../../../views/AuthView'));
const CantLoginView = lazy(() => import('../../../views/CantLoginView'));
const CheckEmailView = lazy(() => import('../../../views/CheckEmailView'));
const NewPasswordView = lazy(() => import('../../../views/NewPasswordView'));
const ReconfirmAccountView = lazy(
  () => import('../../../views/ReconfirmAccountView')
);
const ResetPasswordView = lazy(
  () => import('../../../views/ResetPasswordView')
);
const UnlockAccountView = lazy(
  () => import('../../../views/UnlockAccountView')
);
const WrongDeviceView = lazy(() => import('../../../views/WrongDeviceView'));
const OtpLoginSubmit = lazy(
  () => import('../../../components/forms/LoginForm/OtpLogin/OtpLoginSubmit')
);

function AnonymousPage(): ReactElement {
  return (
    <Routes>
      <Route
        path={`/${AuthForm.Login}`}
        element={<AuthView form={AuthForm.Login} />}
      />
      <Route
        path={`/${AuthForm.SignUp}`}
        element={<AuthView form={AuthForm.SignUp} />}
      />
      <Route path="/login-help" element={<CantLoginView />} />
      <Route path="/new-password" element={<NewPasswordView />} />
      <Route path="/forgot-password" element={<ResetPasswordView />} />
      <Route path="/resend-confirmation" element={<ReconfirmAccountView />} />
      <Route path="/unlock-account" element={<UnlockAccountView />} />
      <Route path="/check-email-magic-link" element={<CheckEmailView />} />
      <Route path="/wrong-device" element={<WrongDeviceView />} />
      <Route path="/otp-login/submit" element={<OtpLoginSubmit />} />
      <Route
        path="*"
        element={<Navigate to={`/login${importantQueryString()}`} />}
      />
    </Routes>
  );
}

export default appPage(AnonymousPage);
